export const formatTimeForAudioDownloads = (date) => {
  const dateWithoutFormatting = new Date(date);

  if (!isNaN(dateWithoutFormatting)) {
    return dateWithoutFormatting.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  } else {
    return null;
  }
};
